import { ParagraphSM, TitleXS } from '@/atoms/Text'

interface TorchStepsCardProps {
  icon: React.ReactNode
  title: string
  description: string
}

export const TorchStepsCard: React.FC<TorchStepsCardProps> = ({ icon, title, description }) => {
  return (
    <div className="flex min-w-fit flex-col justify-center rounded-2xl bg-core-gray-900 px-6 py-[16px] md:min-w-[48%] md:items-start md:px-8 md:py-6 lg:min-w-[15%] xl:gap-4 xl:p-10 se:min-w-[253px] se:px-4 se:py-3 3xl:w-[25%]">
      <div className="flex flex-row items-center gap-3 md:max-w-[257px] lg:max-w-[268px] lg:flex-col lg:items-start lg:gap-10 se:gap-2">
        {icon}
        <TitleXS className="se:photon-caption-md md:photon-title-md xl:photon-title-lg" color="white" weight="bold">
          {title}
        </TitleXS>
      </div>
      <ParagraphSM
        className="se:photon-caption-sm xl:photon-paragraph-md md:max-w-[257px] lg:max-w-[268px] 3xl:max-w-fit"
        color="core-gray-500"
        weight="normal"
      >
        {description}
      </ParagraphSM>
    </div>
  )
}
